import React from "react";
import Arrow from 'Assets/images/arrow.svg';
import styles from './DropdownLoqate.module.scss';

const DropdownLoqate = ({ addressList, showDropDown, onItemClick }) => {
  return (
    <ul
      className={`${showDropDown && addressList.length !== 0 ? styles.dropdownContainer : "d-none"}`}
    >
      {addressList?.map((rec) => (
        <li
          key={rec.id}
          onClick={() => onItemClick(rec)}
          className={styles.addressListItem}
        >
          <div className={styles.addressText}>
            {rec.Text}
            <span className={styles.addressDescription}>
              {rec.Description}
            </span>
          </div>
          
          {rec.Type !== "Address" && (
            <img 
              className={styles.arrowIcon}
              src={Arrow} 
              alt="more" 
            />
          )}
        </li>
      ))}
    </ul>
  );
};

export default DropdownLoqate;
